import { profileAtom } from "@/atoms"
import { Callout } from "@/components/ui"
import { useAtomValue } from "jotai"

/** Explains the contact and resource scope of an unverified visitor session. */
export function GuestSessionNotice() {
  const profile = useAtomValue(profileAtom)
  if (profile?.sessionKind !== "guest_v1" || profile.phoneVerified !== false) return null
  return (
    <Callout tone="info" size="sm" role="none">
      Você está como visitante. O telefone é um contato não verificado; os pedidos e endereços exibidos pertencem somente a esta sessão.
    </Callout>
  )
}
